<div [class.isPrinting]="printService.isPrinting">
  <div class="row  margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-follicular" id="scans">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-follicular data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal ">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Follicular Scans
              </label>
            </div>
            <div class="col-md-6  padding-right-0px display-edit">
              <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
              <div class="row float-right margin-left-0px margin-right-0px">
                <div class="offset-md-3 col-md-1  padding-left-0px">
                  <!--<a class="nav-link-hand education-navlink data-color-new" title="To View images">
                    <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
                  </a>-->
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-long-arrow-alt-up font-size-11"></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-long-arrow-alt-down font-size-11"></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <a class="nav-link-hand education-navlink" title="print" (click)="printfollicular2()">
                    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                  </a>
                </div>
              </div>




            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="table-component overflow-x margin-top-10 margin-left-13px">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero">

                <thead class="">
                  <tr>


                    <th class="font-weight-normal td-padding-tb td-width-107px">Date</th>

                    <th class="padding-left-0px font-weight-normal td-padding-tb td-width-162px">Endometrium</th>
                    <th class="font-weight-normal td-padding-tb padding-left-10px">Comments</th>
                    <th class="font-weight-normal td-padding-tb padding-left-10px">Ovaries Left</th>
                    <th class="font-weight-normal td-padding-tb padding-left-10px">Ovaries Right</th>
                    <th></th>
                  </tr>
                  <!--<tr>
                    <th class="td-padding-tb "></th>
                    <th class="td-padding-tb"></th>
                    <th class="td-padding-tb font-weight-normal">Left</th>
                    <th class="td-padding-tb font-weight-normal">Right</th>
                  </tr>-->
                </thead>
                <tbody class="table-body">
                  <tr *ngFor="let s of CurrentFollicularScanDetailController">


                    <td class="padding-top-5px ">
                      <label class="margin-bottom-0px font-size-14"> {{s.ScanDate| date:'MMM-dd-yyyy'}}</label>

                    </td>

                    <td class="td-padding-tb padding-left-0px">
                      <div><label class="font-size-15px font-weight-bold color-Assign margin-bottom-0px">{{s.EndometriumThickness}}{{s.EndometriumThicknessUnits}}</label></div>
                      <div class="td-padding-tb td-elipsis2">{{s.EndometriumDetails}}</div>
                    </td>
                    <td class="padding-top-5px ">
                      <label class="margin-bottom-0px font-size-14">{{s.Comments}}</label>

                    </td>
                    <td class="td-padding-tb align-top td-padding-left-9px">
                      <!--<div>

                      <label class="margin-bottom-0px">4(11.5)</label>
                      </div>-->
                      <div class="row">
                        <div class="col-md-1 padding-right-23px margin-top-10 margin-right-18px margin-bottom-3px" *ngFor="let od of GetOvaryDetails(s.FollicularGrowth, 'Left')">
                          <div class="badge badge-service2-left margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                            <!--<div class="row">
                              <label class="margin-bottom-0px margin-left-13px color-datacolor">4</label>
                            </div>-->
                            <div class="badge inner-badge border-radius-50p">{{od.Count}}</div>
                            <label class="margin-top-4px font-size-15px margin-bottom-3px">{{od.Size}}</label>


                          </div>
                        </div>
                      </div>
                      <!--<div *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                        <label class="margin-bottom-0px">{{l.OvarPos}}</label>
                      </div>-->


                    </td>

                    <td class="td-padding-tb align-top td-padding-left-9px">
                      <div class="row">
                        <div class="col-md-1 padding-right-23px margin-top-10 margin-right-18px" *ngFor="let od of GetOvaryDetails(s.FollicularGrowth, 'Right')">
                          <div class="badge badge-service2-right margin-left-10px padding-top-0px padding-bottom-0px border-radius-0px">
                            <!--<div class="row">
                              <label class="margin-bottom-0px margin-left-13px color-datacolor">4</label>
                            </div>-->
                            <div class="badge inner-badge border-radius-50p">{{od.Count}}</div>
                            <label class="margin-top-4px font-size-15px margin-bottom-3px">{{od.Size}}</label>


                          </div>
                        </div>

                      </div>
                      <!--<div><label class="margin-bottom-0px">3(13.2)</label></div>
                      <div><label class="margin-bottom-0px">1(17.5)</label></div>-->
                    </td>


                    <td class="padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                      <a class="nav-link-hand education-navlink" title="print" (click)="SelectGrowthCode(s)">
                        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                      </a>
                    </td>


                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

